module.exports = {
      id: "instagram-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#instagram",
      toString: function () {
        return this.url;
      }
    }